import { FieldProps, FieldHelperProps } from "formik";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import has from "lodash/has";
import findIndex from "lodash/findIndex";

export const computedStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "28px",
    height: "36px"
  }),
  container: (provided, state) => ({
    ...provided,
    minWidth: "90px"
  }),
  multiValue: (base, state) => {
    return state.data.isFixed ? { ...base, backgroundColor: "gray" } : base;
  },
  multiValueLabel: (base, state) => {
    return state.data.isFixed
      ? {
          ...base,
          fontWeight: "bold",
          color: "white",
          paddingRight: 6
        }
      : base;
  },
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: "none" } : base;
  },
  menuList: (base, state) => {
    return {
      ...base,
      zIndex: 5
    };
  }
};

/**
 * Options can only be array right now.
 * Option groups is not yet supported.
 * @param {Array[object]} options
 */
export const SelectField = ({
  name,
  value,
  onBlur,
  setFieldValue,
  setFieldTouched,
  styles,
  options,
  isMulti = false,
  isCreatable = false,
  isClearable = false,
  ...props
}) => {
  if (typeof setFieldValue !== "function") {
    throw new Error("setFieldValue must be set to a function");
  }
  if (typeof setFieldTouched !== "function") {
    throw new Error("setFieldTouched must be set to a function");
  }
  const onChange = inputValue => {
    if (inputValue) {
      setFieldValue(
        name,
        isMulti
          ? inputValue
            ? inputValue.map(item => item.value)
            : []
          : inputValue.value
      );
    } else {
      setFieldValue(name, isMulti ? [] : null);
    }
  };

  const isSameOption = (isMulti, value) => {
    if (isMulti) {
      return option => {
        if (has(value[0], "id")) {
          return findIndex(value, item => item.id === option.id) > 0;
        } else {
          return value.find(option.value) > 0;
        }
      };
    } else {
      return option => {
        if (has(value, "id")) {
          return option.value.id === value.id;
        } else {
          return option.value === value;
        }
      };
    }
  };
  const getValue = () => {
    if (options && value) {
      if (has(value, "id")) {
        return isMulti
          ? options.filter(
              option => value.findIndex(item => item.id == option.value.id) >= 0
            )
          : options.find(option => option.value.id == value.id);
      } else {
        return isMulti
          ? options.filter(option => value.indexOf(option.value) >= 0)
          : options.find(option => option.value === value);
      }
    } else {
      return isMulti ? [] : "";
    }
  };

  return isCreatable ? (
    <CreatableSelect
      name={name}
      defaultValue={getValue()}
      onChange={onChange}
      onBlur={e => {
        onBlur(e);
        setFieldTouched(name, true);
      }}
      styles={{
        computedStyles,
        ...styles
      }}
      options={options}
      isMulti={isMulti}
    />
  ) : (
    <Select
      name={name}
      defaultValue={getValue()}
      value={getValue()}
      onChange={onChange}
      onBlur={onBlur}
      styles={computedStyles}
      options={options}
      isMulti={isMulti}
      isClearable={isClearable}
    />
  );
};

export default SelectField;
